import React from 'react'
import classes from './ErrorPage.module.css'

const ErrorPage = (props) => (
        <div className={classes.errorImage}>
                <div className={classes.top}>
                    <h1>{props.message}</h1>
                </div>
        </div>
)
export default ErrorPage